<!-- 话题PK入口挂件 -->
<template>
  <div class="plv-iar-topic__pendant">
    <pendant
      :icon-url="iconUrl"
      :show-tooltip="false"
      @click="$emit('click')"
    />
  </div>
</template>

<script>
import Pendant from '../pendant/pendant.vue';
import normalIconUrl from './imgs/pendant.png';

export default {
  name: 'TopicEntrance',
  components: {
    Pendant,
  },
  props: {
    entranceImg: {
      type: [String, undefined],
      default: undefined
    },

  },
  computed: {
    iconUrl() {
      return this.entranceImg || normalIconUrl;
    },
  },
};
</script>
